import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse, IAttachment } from '../interfaces';

const basePath = '/assets/attachments';

/* eslint-disable implicit-arrow-linebreak */

export const getAssetAttachments = (fileName: string, assetId: string, expiresInHours: number = 1): AxiosPromise<IApiResponse<Array<IAttachment>>> =>
  vaultApi.getInstance().get(`${basePath}/${assetId}?filename=${fileName}&expires=${expiresInHours}`);
